import styled from 'styled-components';
import { H6 } from 'components/Typography';
import _LoadingOverlay from 'components/LoadingOverlay';
import _ButtonUpload from 'components/ButtonUpload';
import { sizes } from 'style';
import { th } from 'style/theme';

export const SummarySection = styled.div`
  position: relative;
  padding-bottom: 22px;
  margin-bottom: 22px;

  ::after {
    content: ' ';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: ${th('colors.turquoise')};
  }
`;

export const SummaryField = styled.div`
  margin-top: 16px;

  @media ${sizes.desktop} {
    display: flex;
    flex-direction: row;
    gap: 40px;

    > :first-child {
      width: 200px;
      flex-shrink: 0;
    }
  }
`;

export const SummaryBox = styled.div`
  max-height: 205px;
  padding: 8px;
  margin-top: 8px;
  border: 1px solid ${th('colors.turquoise')};
  border-radius: 5px;
  overflow: scroll;

  @media ${sizes.desktop} {
    width: 100%;
    min-width: 220px;
    margin-top: 0;
  }
`;
